<template>
    <button
    @click="$emit('click')"
    @keyup.enter="$emit('click')"
    class="aup-base-button py-1 px-4 t-micro text-uppercase"
    :disabled="isDisabled"
    :type="type"
    :class="{
        'solid-orange': (filled && color == 'orange' && !isDisabled),
        'solid-black': (filled && color == 'black' && !isDisabled),
        'solid-white': (filled && color == 'white' && !isDisabled),
        'solid-gray': (filled && isDisabled),
        'empty-orange': (!filled && color == 'orange' && !isDisabled),
        'empty-black': (!filled && color == 'black' && !isDisabled),
        'empty-white': (!filled && color == 'white' && !isDisabled),
        'empty-light': (!filled && color == 'light' && !isDisabled),
        'empty-gray': (!filled && isDisabled),
        'thin-border-black': (border == 'thin' && color == 'black'),
        'thin-border-orange': (border == 'thin' && color == 'orange'),
        'no-border': (border == 'none'),
        'round-border': (border == 'round'),
        'no-padding': (noPadding),
        'low-priority': isLowPriority,
    }"
    >
        <slot/>
    </button>
</template>

<script>
export default {
    name: 'BaseButton',
    props: {
        color: {
            default: 'orange',
            type: String
        },
        filled: {
            default: true,
            type: Boolean
        },
        isDisabled: {
            default: false,
            type: Boolean
        },
        border: {
            default: 'regular',
            type: String
        },
        noPadding: {
            default: false,
            type: Boolean
        },
        isLowPriority: {
            default: false,
            type: Boolean,
        },
        type: {
            default: 'button',
            type: String
        }
    }
};
</script>

<style lang="scss">
@import '../../assets/scss/all.scss';
    .aup-base-button {
        --box-shadow-color: $primary;

        -webkit-appearance: none;
        border-width: 2px;
        border-style: solid;
        color: white;
        overflow: hidden;
        transition: all 0.3s ease-in-out;

        &:hover {
            cursor: pointer;
            opacity: .8;
        }

        &:focus {
            outline: none;
            box-shadow: 0 0 0 2px lighten($primary, 30%);
        }

        $baseButtonLightGray: $gray-400;
        $baseButtonDarkGray: $gray-400;
        $baseButtonOrange: $primary;
        $baseButtonBlack: $sony-black;
        $baseButtonWhite: $sony-white;

        &.solid-orange {
            background: $primary;
            border-color: $primary;

            &:focus, &:hover {
                box-shadow: none;
                background-color: scale-color($primary, $lightness: 20%);
                border-color: scale-color($primary, $lightness: 20%);
                //temp until all buttons adjusted with hover states
                opacity: 1;
            }
        }
        &.solid-black {
            background: $baseButtonBlack;
            border-color: $baseButtonBlack;
        }
        &.solid-white {
            background: $baseButtonWhite;
            color: $baseButtonBlack;
            border-color: $baseButtonWhite;
        }
        &.solid-gray {
            background: $baseButtonLightGray;
            border-color: $baseButtonLightGray;
            pointer-events: none;
            &:hover {
                cursor: default;
                opacity: 1;
            }
            &:focus {
                outline: 0;
            }
        }


        &.empty-orange {
            background: transparent;
            color: $primary;
            border-color: $primary;
        }
        &.empty-black {
            background: transparent;
            color: $baseButtonBlack;
            border-color: $baseButtonBlack;
            &:focus {
                background: $gray-800;
                color: $baseButtonWhite;
                border-color: $gray-800;
                outline: none;
                box-shadow: none;
            }
            &:hover {
                background: $baseButtonBlack;
                color: $baseButtonWhite;
                //temp until all buttons adjusted
                opacity: 1;
            }
        }
        &.empty-white {
            background: transparent;
            color: $baseButtonWhite;
            border-color: $baseButtonWhite;
        }
        &.empty-light {
            background: transparent;
            color: $baseButtonBlack;
            border-color: $baseButtonDarkGray;
            border-width: 1px;
        }
        &.empty-gray {
            background: transparent;
            color: $baseButtonDarkGray;
            border-color: $baseButtonDarkGray;
            pointer-events: none;
            &:hover {
                cursor: default;
                opacity: 1;
            }
            &:focus {
                outline: 0;
            }
        }

        &.low-priority {
            background: transparent;
            color: $gray-700;
            border-color: $gray-700;
            &:hover {
                background-color: $gray-700;
                border-color:$gray-700;
                color: $white;
            }
            &:focus {
                outline: 0;
                color: $white;
                box-shadow: inset 0 0 1px 2px $white;
                background-color: $gray-700;
                border-color: $gray-700;
            }
        }

        &.thin-border-black {
            border-width: 1px;
            border-color: $baseButtonLightGray;
        }
        &.thin-border-orange {
            border-width: 1px;
            border-color: $primary;
        }
        &.round-border {
            border-radius: 100%;
            width: 30px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 !important;
            &>span{
                width: 100%;
                height: 100%;
            }
        }

        &.no-border {
            border-width: 0;
        }

        &.no-padding {
            padding: 0 !important;
        }
    }
</style>



